import React, { useState } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { About } from './components/About';
import { PracticeAreas } from './components/PracticeAreas';
import { Video } from './components/Video';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PhoneStrip } from './components/PhoneStrip';
import { LanguageProvider } from './components/LanguageContext';
import { IntroAnimation } from './components/IntroAnimation';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  const [introComplete, setIntroComplete] = useState(false);
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-black text-white font-sans selection:bg-crimson selection:text-white" data-id="element-1">
        <IntroAnimation onComplete={() => setIntroComplete(true)} data-id="element-2" />

        <Nav data-id="element-3" />
        <main data-id="element-4">
          <Hero introComplete={introComplete} data-id="element-5" />
          <Trust data-id="element-6" />
          <About data-id="element-7" />
          <PracticeAreas data-id="element-8" />
          <Video data-id="element-9" />
          <Testimonials data-id="element-10" />
          <FinalCTA data-id="element-11" />
        </main>
        <Footer data-id="element-12" />
        <PhoneStrip data-id="element-13" />
        <PurchaseToast data-id="element-14" />
      </div>
    </LanguageProvider>;
}